import { CellContext } from '@tanstack/react-table';

import { isoDateFromTimestamp } from '@/portainer/filters/filters';
import { useUser, UserNotFoundError } from '@/portainer/users/queries/useUser';

import { EdgeConfiguration } from '../../types';

import { columnHelper } from './helper';

export const updated = columnHelper.accessor('updated', {
  id: 'updated',
  header: 'Updated',
  cell: Cell,
});

function Cell({
  getValue,
  row: {
    original: { createdBy, updatedBy },
  },
}: CellContext<EdgeConfiguration, EdgeConfiguration['updated']>) {
  const value = getValue();
  const { data, error } = useUser(updatedBy || createdBy, {
    silent: true,
  });

  let content = '-';
  if (value) {
    content = isoDateFromTimestamp(value);
    if (data) {
      content += ` by ${data.Username}`;
    } else if (error instanceof UserNotFoundError) {
      content += ' by (deleted user)';
    }
  }

  return <span>{content}</span>;
}
